class PopupMessageBase {
	constructor() {
		this._init()
	}
	_init() {
		const el = document.querySelector('[data-popup-message-base]');
		if (!el)
			return;
		el.querySelector('button').addEventListener('click', function() {
			el.addEventListener('transitionend', () => {
				el.remove();
			})
			el.classList.remove('popup-message-base-is-visible');
		});
	}
}

export default PopupMessageBase